<template>
	<div class="online-back">
		<span class="cntitle">{{mainWord4.chTitle}}</span>
		<form class="form"> 
			<div class="rightstar">
				<newStar class="star"></newStar>
				<span class="right-word">{{onlineFacebook[0]}}</span>
			</div>
			<div class="maininner">
				<div class="label">
					<newStar class="star"></newStar>
					<span class="nameword">{{onlineFacebook[1]}}</span>
				</div>
				<input type="text" class="innerWord" />
			</div>
			<div class="maininner">
				<div class="label">
					<newStar class="star"></newStar>
					<span class="nameword">{{onlineFacebook[2]}}</span>
				</div>
				<input type="text" class="innerWord" :placeholder="$t('onlineFacebook[3]')"/>
			</div>
			<div class="maininner">
				<div class="label">
					<span class="nameword">{{onlineFacebook[4]}}</span>
				</div>
				<input type="text" class="innerWord" :placeholder="$t('onlineFacebook[5]')"/>
			</div>
			<div class="maininner">
				<div class="label">
					<newStar class="star"></newStar>
					<span class="nameword">E-mail</span>
				</div>
				<input type="text" class="innerWord" :placeholder="$t('onlineFacebook[6]')"/>
				<span class="postword">{{onlineFacebook[7]}}</span>
				<input type="text" class="innerWord2" />
			</div>
			<div class="maininner">
				<div class="label">
					<newStar class="star"></newStar>
					<span class="nameword">{{onlineFacebook[8]}}</span>
				</div>
				<input type="text" class="innerWord"/>
			</div>
			<div class="maininner">
				<div class="label">
					<span class="nameword">{{onlineFacebook[9]}}</span>
				</div>
				<textarea rows="10" class="infomation"></textarea>
			</div>
			<div class="maininner">	
				<button class="buttonyes">{{onlineFacebook[10]}}</button>	
			</div>		
		</form>
	</div>
</template>

<script type="text/ecmascript-6">
	import newStar from 'common/only-svg/newstar-svg'

	export default {
		data() {
			return {
			}
		},
		components: {
			newStar
		},
		computed: {
			mainWord4() {
				return this.$t('mainWord4')
			},
			onlineFacebook() {
				return this.$t("onlineFacebook")
			}
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"
	.form
		width: 80%
		margin: 30px 0
		border-top: 14px solid $color-theme
		padding-top: 10px
		@media screen and (max-width:860px)
			margin: 20px 0
		.rightstar
			display: flex
			justify-content: flex-end
			margin-bottom: 10px
			align-items: center
			@media screen and (max-width:860px)
				margin-bottom: 2px
		.maininner
			display: flex
			align-items: center
			margin-bottom: 10px
			@media screen and (max-width:860px)
				flex-direction: column
				align-items: flex-start
			.label
				display: flex
				width: 15%
				flex: 0 0 auto
				justify-content: flex-end
				padding-right: 10px
				@media screen and (max-width:860px)
					width: 50%
					justify-content: flex-start
				.star
					margin-right: 5px
			.innerWord
				border: 1px solid $color-text-m
				flex: 4 0
				padding: 5px 0px
				@media screen and (max-width:860px)
					width: 100%
			.innerWord::-webkit-input-placeholder
				font-size: 0.6rem
				padding-left: 3px
				color: #aaa
			.postword
				padding: 0 5px
				flex: 1 1	
				white-space: nowrap
				@media screen and (max-width:860px)
					margin-top: 10px
			.innerWord2
				width: 100px
				flex: 0 0 auto
				border: 1px solid $color-text-m
				padding: 5px 0
				@media screen and (max-width:860px)
					width: 100%
			.buttonyes
				padding: .3em 1em
				border: 1px solid rgba(0,0,0,.1)
				background-color: $color-theme
				border-radius: 4px
				box-shadow: 0 1px 5px gray
				color: white
				text-shadow: 0 -1px 1px #335166
				font-size: 120%
				line-height: 2
				margin: 5px 0 0 15%
				@media screen and (max-width:860px)
					margin: 5px 0 0 0
				&:hover
					background-color: $color-text-g
					text-shadow: 0 0px 0px #335166
			.infomation
				border: 1px solid $color-text-m
				width: 100%
		.maininner:nth-child(4) .nameword
			margin-left: 12px
		.maininner:nth-child(5) .postword
			margin-left: 6px
</style>



// WEBPACK FOOTER //
// src/components/tab-item/online-back.vue